import React, { Component, Fragment } from 'react';
import {
  Grid,
  Input,
  InputLabel,
  FormControl,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core';

import axios from 'Axios';
import { setImageForUpload } from 'Utils';
import Snackbar from 'Snackbar';
import Modal from 'Components/Modal';
import Container from './components/Container';
import InnerContainer from '../components/InnerContainer';
import Required from '../components/Required';
import Footer from '../components/Footer';
import Header from '../../Header';
import ReqMsgWraper from '../../RequiredFieldsMessageWrapper';
import InfoWebSite from '../../InfoMessage';

class Step2 extends Component {
  state = { msg: '' };

  setImage = setImageForUpload;

  showSnackbar = msg => {
    this.setState({ openSnackbar: true, msg });
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount = () => {
    // validating the form when it's mounted
    this.props.changeFormSchema(this.props.validateForm);

    const { step, type } = this.props.registrationData;
    if (
      step === 'STEP_3' ||
      step === 'STEP_4' ||
      step === 'FINISHED' ||
      type === 'COMPANY_USER_REGISTRATION' ||
      type === 'ARUP_REGISTRATION'
    ) {
      this.props.next();
    }
  };

  askForNextStep = ({ company, acctok, next }) => () => {
    const isNonArupRegistration =
      this.props.registrationData.type === 'NON_ARUP_REGISTRATION';
    const country = company.country;
    const countriesWithRegions = this.props.values.countriesWithRegions;

    var extractRegionFromSelectedCountry;

    for (const region in countriesWithRegions) {
      if (countriesWithRegions[region].includes(country)) {
        extractRegionFromSelectedCountry = region;
        break;
      } else {
        extractRegionFromSelectedCountry = '';
      }
    }

    const nonArupPayload = {
      companyName: company.name,
      county: company.address,
      companyAddress: company.companyCountry,
      companyCity: company.companyCity,
      companyCountry: country,
      website: company.website,
      phone: company.phone,
      registeredCompanyNumber: company.registeredCompanyNumber
        ? company.registeredCompanyNumber
        : null,
      regionName: extractRegionFromSelectedCountry,
    };

    const arupPayload = {
      companyName: company.name,
      website: company.website,
      phone: company.phone,
      companyAddress: company.address,
      registeredCompanyNumber: company.registeredCompanyNumber
        ? company.registeredCompanyNumber
        : null,
      companyCountry: company.companyCountry,
      companyCity: company.companyCity,
    };

    const payload = isNonArupRegistration ? nonArupPayload : arupPayload;

    axios
      .post(`registration/${acctok}`, payload)
      .then(response => {
        if (response.data) next();
      })
      .catch(error => {
        const msg = error.response
          ? error.response.data.message
          : 'Failed to connect to the database';
        this.showSnackbar(msg);
      });
  };

  render() {
    const {
      values: { company },
      handleChange,
      next,
      step,
      acctok,
      registrationData,
      isValid,
      countries,
    } = this.props;

    const nonArupRegistration =
      registrationData.type === 'NON_ARUP_REGISTRATION';

    const countriesToExclude = ['Hong Kong', 'Kosovo', 'Antarctica'];

    const filterOutSomeCountries = countries.filter(
      country => !countriesToExclude.includes(country)
    );

    return (
      <Fragment>
        <Modal.Header>
          <Header activeStep={step.id} registrationData={registrationData} />
        </Modal.Header>

        <Modal.Body>
          <Container>
            <InnerContainer>
              <Grid container spacing={16}>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="name">
                      {nonArupRegistration
                        ? 'Company name'
                        : 'Registered Company name'}{' '}
                      {!company.name && <Required />}
                    </InputLabel>
                    <Input
                      id="name"
                      fullWidth
                      name="company.name"
                      value={company.name}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="name">
                      {nonArupRegistration
                        ? 'Street address'
                        : 'Registered Company country'}{' '}
                      {!company.companyCountry && <Required />}
                    </InputLabel>
                    <Input
                      id="companyCountry"
                      fullWidth
                      name="company.companyCountry"
                      value={company.companyCountry}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="name">
                      {nonArupRegistration ? 'City' : 'Registered Company city'}{' '}
                      {!company.companyCity && <Required />}
                    </InputLabel>
                    <Input
                      id="companyCity"
                      fullWidth
                      name="company.companyCity"
                      value={company.companyCity}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="address">
                      {nonArupRegistration
                        ? 'County/State'
                        : 'Registered Company address'}
                    </InputLabel>
                    <Input
                      id="address"
                      fullWidth
                      name="company.address"
                      value={company.address}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
                {nonArupRegistration ? (
                  <Grid item xs={6}>
                    <FormControl fullWidth margin="normal">
                      <InputLabel htmlFor="country">
                        Country {!company.address && <Required />}
                      </InputLabel>
                      <Select
                        id="country"
                        fullWidth
                        name="company.country"
                        value={company.country}
                        onChange={handleChange}
                      >
                        {filterOutSomeCountries &&
                          filterOutSomeCountries.sort().map(country => {
                            return (
                              <MenuItem key={country} value={country}>
                                {country}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Grid>
                ) : null}
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="phone">
                      Phone {!company.phone && <Required />}
                    </InputLabel>
                    <Input
                      id="phone"
                      fullWidth
                      type="tel"
                      name="company.phone"
                      value={company.phone}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="registeredCompanyNumber">
                      {nonArupRegistration
                        ? 'Mobile'
                        : 'Registered company number'}
                    </InputLabel>
                    <Input
                      id="registeredCompanyNumber"
                      fullWidth
                      type="text"
                      name="company.registeredCompanyNumber"
                      value={company.registeredCompanyNumber}
                      onChange={handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel htmlFor="website">
                      http://yourcompany.website
                      {!company.website && <Required />}
                    </InputLabel>
                    <Input
                      id="website"
                      fullWidth
                      name="company.website"
                      value={company.website}
                      onChange={handleChange}
                    />
                  </FormControl>
                  <InfoWebSite>
                    (Copy and paste full address from browser)
                  </InfoWebSite>
                </Grid>
              </Grid>
            </InnerContainer>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Footer>
            {!isValid && (
              <ReqMsgWraper>
                Required fields are indicated with
                <Required />
              </ReqMsgWraper>
            )}

            <Button
              disabled={!isValid}
              onClick={this.askForNextStep({ company, acctok, next })}
              variant="contained"
              color="primary"
            >
              Next
            </Button>
          </Footer>
        </Modal.Footer>
        <Snackbar
          open={this.state.openSnackbar}
          onClose={this.handleCloseSnackbar}
          msg={this.state.msg}
        />
      </Fragment>
    );
  }
}

export default Step2;
